import PropTypes from 'prop-types';
import React from 'react';
import { Box, Divider, List } from '@mui/material';
import { Menus } from 'config/menus';
import Paths from 'config/paths';

/**
 * Acciones para usuario sin sesión, al inicio del sidebar: "Iniciar Sesión" y
 * "Registrarse" (links vía mapView, que respeta su tipo ANONYMOUS).
 */
function AuthActions({ mapView }) {
  const views = [Paths.LOGIN, Paths.REGISTER]
    .map((path, i) => mapView(`auth-${i}`, path, Menus[path]))
    .filter((v) => v != null);

  if (views.length === 0) return null;

  return (
    <Box sx={{ px: 2, pt: 1 }}>
      <List disablePadding>{views}</List>
      <Divider sx={{ mt: 1 }} />
    </Box>
  );
}

AuthActions.propTypes = {
  mapView: PropTypes.func.isRequired,
};

export default AuthActions;
